export const serializeFilterParams = (filters?: Record<string, unknown>): Record<string, unknown> | undefined => {
  if (!filters) return undefined;

  const serializedEntries = Object.entries(filters)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        const primitiveValues = value.filter(
          (item): item is string | number | boolean =>
            typeof item === "string" || typeof item === "number" || typeof item === "boolean",
        );

        if (primitiveValues.length === 0) {
          return [key, undefined] as const;
        }

        return [key, primitiveValues.join(",")] as const;
      }

      return [key, value] as const;
    })
    .filter(([, value]) => value !== undefined);

  return Object.fromEntries(serializedEntries);
};
